import { sendToGtm } from '@s1/core/event-tracking';

const sendEstReadingTimeToGA = () => {
  window.s1.wpDataStack = window.s1.wpDataStack || {};

  if (typeof window.s1.wpDataStack.pageInfo.est_reading_time !== 'undefined') {
    const trackingObject = {
      event: 'Unified Event',
      eventCategory: 'Estimated Reading Time',
      eventAction: 'Get Estimated Reading Time',
      eventLabel: 'Estimated Reading Time',
      eventValue: window.s1.wpDataStack.pageInfo.est_reading_time,
    };

    sendToGtm(trackingObject);
    console.log('EstReadingTime Sent to dataLayer', trackingObject);
  }
};

export default sendEstReadingTimeToGA;
